module.exports = __webpack_public_path__ + "img/jbzx_img.4d51edee.png";